import React from "react";
import { Box, Typography, TextField, IconButton, Tooltip, AvatarGroup, Avatar, Button } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { stringAvatar } from '../utils/avatar.js';


export default function Conversation({widgetConfig,agentsEnabled,enabledAgents,setViewAgents,message,setMessage,handleSendMessage}) {
  return (
    <React.Fragment>
      <Box
        sx={{
          overflowY: 'auto',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          scrollbarWidth: "none", // Firefox
          "msOverflowStyle": "none", // IE and Edge
          "&::-webkit-scrollbar": {
              width: "0.4em", // Adjust as needed
          },
          "&::-webkit-scrollbar-track": {
              background: "transparent", // Make the track invisible
          },
          "&::-webkit-scrollbar-thumb": {
              background: "transparent", // Make the thumb (scrollbar) invisible
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',flexDirection: 'column',flexGrow:1,
            pt:10,
            pb:25,
            pl: 2,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              width: "0.4em",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "transparent",
            },
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              borderRadius: "0px 16px 16px 16px",
              p: 2,
              maxWidth: "60%",
              mt: 3,
              boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
            }}
          >
            <Typography sx={{ fontSize: "14px",whiteSpace: 'pre-wrap' }}>
              {widgetConfig.greeting}
            </Typography>
          </Box>
        </Box>
      </Box>
    
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          p: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {agentsEnabled && enabledAgents.length>0 &&
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent:'center',alignItems:'center',
            }}
          >
            <Box
              sx={{
                width:'100%',
                display: "flex",
                flexDirection: "row",
                justifyContent:'left',
                alignItems:'center',
                minHeight:'70px',
                background:'#FFFFFF',
                mt: -4,
                border:'1px solid #D0FFF6',
                borderRadius:'10px',
                pl:2,
                pr:2,
                gap:2
              }}
            >
              <AvatarGroup 
                sx={{
                  '& .MuiAvatar-root': {
                    width:40,
                    height:40
                  },
                  '& .MuiAvatarGroup-avatar': {
                    width:40,
                    height:40
                  },
                }}
                total={enabledAgents.length}
                max={3}
              >
                {enabledAgents.map((agent, index) => (
                  <Tooltip key={index} title={agent.name || "Agent"} arrow placement="top">
                      <Avatar 
                        {...stringAvatar(agent.name || "Agent")}
                        onClick={() => handleSendMessage(agent?.redirectNumber,false)}
                        
                      />
                  </Tooltip>
                ))}
              </AvatarGroup>
              <Typography
                sx={{
                  fontFamily:'DM Sans Bold',
                  fontSize:'16px',
                  color:'#008169',
                }}
              >
              Chat with an Agent
              </Typography>
              <Button
                contained
                size="small"
                sx={{
                  ml:'auto',
                  minWidth:'100px',
                  fontFamily:'DM Sans Bold',
                  background:'#008169',
                  color:'#FFFFFF',
                  textTransform:'none',
                  '&:hover': {
                    background: '#008169',
                    color: '#FFFFFF',
                  },
                }}
                onClick={()=>{setViewAgents(true)}}
              >
                Start 
              </Button>     
            </Box>
          </Box>
        }
        <Box
          sx={{
            pt:2,
            pb: 2,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <TextField
            fullWidth
            multiline
            maxRows={5}
            variant="outlined"
            size="small"
            placeholder="Type your message..."
            value={message}
            onChange={(e)=>{setMessage(e.target.value);}}
            sx={{
              borderRadius: "30px",
              pl: 2,
            
              backgroundColor: "#FFF",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                },
                "& input::placeholder": {
                  fontSize: "14px",
                },
              },
            }}
          />
          <IconButton
            disableRipple
            disableTouchRipple
            disableFocusRipple
            onClick={()=>{handleSendMessage(widgetConfig?.redirectNumber,true)}}
            sx={{
              backgroundColor: "#25D467",
              width: "40px",
              height: "40px",
              ml: 2,
            }}
          >
            <SendIcon sx={{fontSize:20,color:'#FFFFFF'}} />
          </IconButton>
        </Box>
      </Box>
    </React.Fragment>

  );
}
